import { ObjectStore } from '../../../common/core/store/object.store';

export const NodeDoneStore = ObjectStore.create<{
  todayCount?: number;
}>({});
